import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

// Shell of app
import App from './App';
import { AuthProvider } from './Auth';
import ErrorPage from './pages/error';
import DynamicLoginRoute from './components/DynamicLoginRoute';

// New Pages
import Home2 from './pages/HomeFolder/home'
import HRLDetector2 from './pages/DetectorFolder/HRLDetector';
import About from './pages/AboutFolder/About';
import HRLServicesWildfires from './pages/HRLServicesWildfires/HRLServicesWildfires';
import HRLServicesUtility from './pages/HRLServicesUtility/HRLServicesUtility';
import Login2 from './pages/LoginFolder/Login';
import ContactUs from './pages/ContactUsFolder/ContactUs';
import Career from './pages/CareerFolder/Career';
import News from './pages/NewsFolder/News';
import EmailDispatch from './client-dashboard/client-dashboard-product-suite/EmailDispatch/EmailDispatch';
import ApiEndpoint from './client-dashboard/client-dashboard-product-suite/ApiEndpoint/ApiEndpoint';
import Blog from './pages/BlogFolder/Blog';
import BlogPost from './pages/BlogFolder/BlogPost';
import InventoryManagement from './Inventory/InventoryManagement';

// Pages
// import Home from './pages/home';
// import HrlDetector from './pages/hrl-detector';
// import Mission from './pages/mission';
// import HrlMapping from './pages/hrl-mapping';
// import Login from './components/login';
// import Contact from './pages/contact';
// import Opportunities from './pages/opportunities';
// import News from './pages/news';

import HrlFirebird from './pages/hrl-firebird';
import Hotspot from './pages/hotspot';
import FireDetails from './pages/fire-details';
import FnnBackend from './backend/fnnbackend';
import Plot from './backend/pages/Plot';

import Test from './pages/test-flow/fnnbackend';

// Client Dashboard links
import ClientDashboard from './client-dashboard/clientDashboardMain';
import ClientDashboardMapNew from './client-dashboard/clientDashboardMapNew';
import ClientDashboardDocuments from './client-dashboard/client-dashboard-documents/clientDashboardDocuments';
import ClientDashboardDocuments2 from './client-dashboard/client-dashboard-documents/clientDashboardDocuments2';
import ClientRepresentative from './client-dashboard/clientRepresentative/ClientRepresentative';
import ClientFAQ from './client-dashboard/client-dashboard-faqs/ClientFAQ';
import ClientVideoHub from './client-dashboard/client-dashboard-video-hub/ClientVideoHub';
import ClientManual from './client-dashboard/client-dashboard-manual/ClientManual';
import ClientProfile from './client-dashboard/client-dashboard-profile/ClientProfile';
import ClientEsriDashboards from './client-dashboard/client-esri-selection/ClientEsriDashboards';
import ClientEsriCredentials from './client-dashboard/client-esri-selection/ClientEsriCredentials';
import ProductSuite from './client-dashboard/client-dashboard-product-suite/ProductSuite';
import ForeFlight from './client-dashboard/client-dashboard-product-suite/ForeFlight/ForeFlight';
import FiResponse from './client-dashboard/client-dashboard-product-suite/fiResponse/FiResponse';
import RawData from './client-dashboard/client-dashboard-product-suite/RawData/RawData';
import HeatMapMapPublic from './client-dashboard/HeatMapMapPublic';

// Team Portal Pages
import AlertHub from './team-portal/AlertHub/AlertHub';
import MainHubPage from './team-portal/MainHub/MainHubPage';
import CustomerDescription from './team-portal/MarketingTab/CustomerDescription';
import ActiveProducts from './team-portal/MarketingTab/ActiveProducts';
import SelectedProduct from './team-portal/MarketingTab/SelectedProduct';
import MarketingMain from './team-portal/MarketingTab/MarketingMain';
import DetectorStatus from './team-portal/HardwareTab/DetectorStatus';
import HardwareHistory from './team-portal/HardwareTab/HardwareHistory';
import ServerStatus from './team-portal/ServerTab/ServerStatus';
import DataManagement from './team-portal/AITab/DataManagement';
import RequestActivity from './team-portal/AITab/RequestActivity';
import PipelineOverview from './team-portal/AITab/PipelineOverview';
// import ActivityAndPerformance from './team-portal/TOATab/ActivityAndPerformance';
// import ToolsAndRepos from './team-portal/TOATab/ToolsAndRepos';


import {
  createBrowserRouter,
  RouterProvider,
  Navigate,
} from 'react-router-dom';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <App>
        <Home2 />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/test',
    element: (
      <App>
        <Test />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/login',
    element: <DynamicLoginRoute />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/hrl-detector',
    element: (
      <App>
        <HRLDetector2 />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '//',
    element: (
      <App>
        <HRLDetector2 />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hrl-mapping',
    element: (
      <App>
        <HRLServicesWildfires />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hrl-mapping/',
    element: (
      <App>
        <HRLServicesWildfires />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hrl-firebird',
    element: (
      <App>
        <HrlFirebird />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hrl-firebird/',
    element: (
      <App>
        <HrlFirebird />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/mission',
    element: (
      <App>
        <About />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/mission/',
    element: (
      <App>
        <About />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/news',
    element: (
      <App>
        <News />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/news/',
    element: (
      <App>
        <News />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hotspot',
    element: (
      <App>
        <Hotspot />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hotspot/',
    element: (
      <App>
        <Hotspot />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hotspot/:id',
    element: (
      <App>
        <FireDetails />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/contact',
    element: (
      <App>
        <ContactUs />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/contact/',
    element: (
      <App>
        <ContactUs />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/opportunities',
    element: (
      <App>
        <Career />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/opportunities/',
    element: (
      <App>
        <Career />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fountainn',
    element: (
      <App>
        <Blog />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fountainn/',
    element: (
      <App>
        <Blog />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fountainn/post/:postID',
    element: (
      <App>
        <BlogPost />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fountainn/post/:postID/',
    element: (
      <App>
        <BlogPost />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fountainn/blog/:link_name',
    element: (
      <App>
        <BlogPost />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fountainn/blog/:link_name/',
    element: (
      <App>
        <BlogPost />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnnbackend',
    element: <>{<FnnBackend />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnnbackend/',
    element: <>{<FnnBackend />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnnbackend/plot',
    element: <>{<Plot />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_map',
    element: <>{<ClientDashboardMapNew />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_map',
    element: <>{<ClientDashboardMapNew />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_detec_videos',
    element: <>{<ClientDashboardDocuments />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_detec_videos/',
    element: <>{<ClientDashboardDocuments />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_dash_videos',
    element: <>{<ClientDashboardDocuments2 />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_dash_videos/',
    element: <>{<ClientDashboardDocuments2 />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_representative',
    element: <>{<ClientRepresentative />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_representative/',
    element: <>{<ClientRepresentative />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_faqs',
    element: <>{<ClientFAQ />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_faqs/',
    element: <>{<ClientFAQ />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_video_hub',
    element: <>{<ClientVideoHub />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_video_hub/',
    element: <>{<ClientVideoHub />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_manual',
    element: <>{<ClientManual />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_manual/',
    element: <>{<ClientManual />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_profile',
    element: <>{<ClientProfile />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_profile/',
    element: <>{<ClientProfile />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_esri',
    element: <>{<ClientEsriDashboards />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_esri/',
    element: <>{<ClientEsriDashboards />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_esri_credentials',
    element: <>{<ClientEsriCredentials />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_esri_credentials/',
    element: <>{<ClientEsriCredentials />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite',
    element: <>{<ProductSuite />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/',
    element: <>{<ProductSuite />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/foreflight',
    element: <>{<ForeFlight />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/foreflight/',
    element: <>{<ForeFlight />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/firesponse',
    element: <>{<FiResponse />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/firesponse/',
    element: <>{<FiResponse />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/email-dispatch',
    element: <>{<EmailDispatch />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/email-dispatch/',
    element: <>{<EmailDispatch />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/api-endpoint',
    element: <>{<ApiEndpoint />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/api-endpoint/',
    element: <>{<ApiEndpoint />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/raw_data',
    element: <>{<RawData />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_portal_product_suite/raw_data/',
    element: <>{<RawData />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hrl-utility',
    element: (
      <App>
        <HRLServicesUtility />
      </App>
    ),
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/inventory',
    element: <>{<InventoryManagement />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/inventory/',
    element: <>{<InventoryManagement />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/alert_hub',
    element: <>{<AlertHub />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/alert_hub/',
    element: <>{<AlertHub />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },


  {
    path: '/team_portal',
    element: <>{<MainHubPage />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/team_portal/',
    element: <>{<MainHubPage />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/marketing/customers',
    element: <>{<CustomerDescription />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/marketing/customers/',
    element: <>{<CustomerDescription />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/marketing/products',
    element: <>{<ActiveProducts />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/marketing/products/',
    element: <>{<ActiveProducts />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/marketing/products/:productId',
    element: <SelectedProduct />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/marketing/products/:productId/',
    element: <SelectedProduct />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/marketing/main',
    element: <MarketingMain />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/marketing/main/',
    element: <MarketingMain />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/hardware/detector_management',
    element: <DetectorStatus />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/hardware/detector_management/',
    element: <DetectorStatus />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/hardware/history',
    element: <HardwareHistory />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/hardware/history/',
    element: <HardwareHistory />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/server/status',
    element: <ServerStatus />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/server/status/',
    element: <ServerStatus />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/ai/data_management',
    element: <DataManagement />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/ai/data_management/',
    element: <DataManagement />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/ai/request_activity',
    element: <RequestActivity />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/ai/request_activity/',
    element: <RequestActivity />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/ai/pipeline_overview',
    element: <PipelineOverview />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/ai/pipeline_overview/',
    element: <PipelineOverview />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  // {
  //   path: '/toa/activity_and_performance',
  //   element: <ActivityAndPerformance />,
  //   errorElement: (
  //     <App>
  //       <ErrorPage />
  //     </App>
  //   ),
  // },

  // {
  //   path: '/toa/activity_and_performance/',
  //   element: <ActivityAndPerformance />,
  //   errorElement: (
  //     <App>
  //       <ErrorPage />
  //     </App>
  //   ),
  // },

  // {
  //   path: '/toa/tools_and_repositories',
  //   element: <ToolsAndRepos />,
  //   errorElement: (
  //     <App>
  //       <ErrorPage />
  //     </App>
  //   ),
  // },

  // {
  //   path: '/toa/tools_and_repositories/',
  //   element: <ToolsAndRepos />,
  //   errorElement: (
  //     <App>
  //       <ErrorPage />
  //     </App>
  //   ),
  // },

  {
    path: '/fnn_client_dashboard',
    element: <Navigate to="/fnn_portal_map" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_client_dashboard/',
    element: <Navigate to="/fnn_portal_map" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_client_dashboard_map',
    element: <Navigate to="/fnn_portal_map" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_client_dashboard_map/',
    element: <Navigate to="/fnn_portal_map" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_client_dashboard_documents',
    element: <Navigate to="/fnn_portal_video_hub" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_client_dashboard_documents/',
    element: <Navigate to="/fnn_portal_video_hub" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_client_dashboard_esri',
    element: <Navigate to="/fnn_portal_esri" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fnn_client_dashboard_esri/',
    element: <Navigate to="/fnn_portal_esri" replace />,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

  {
    path: '/fl_live_lightning',
    element: <>{<HeatMapMapPublic />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },
  {
    path: '/fl_live_lightning/',
    element: <>{<HeatMapMapPublic />}</>,
    errorElement: (
      <App>
        <ErrorPage />
      </App>
    ),
  },

]);

// Load the react app into our DOM
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <React.StrictMode>
    <AuthProvider>
      {' '}
      {/* AuthProvider in all app context */}
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
